var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LoginPage',{scopedSlots:_vm._u([{key:"append",fn:function(){return [_c('DropWave')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }